import styled from 'styled-components';

export const EditorModalBody = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 40px;
  padding-left: 40px;
`;
